<template>
  <main class="leadgen-page">
    <HeroSection
      :page="page"
      :subscribed="subscribed"
      @subscribed="autoDownload = true"
      @download-file="downloadPdf"
    />
    <component
      :is="articleComponent"
      :page="page"
      :subscribed="subscribed"
      @download-file="downloadPdf"
    />
    <RelatedArticlesSection
      v-if="hasBlogArticles"
      :articles="page.related_articles"
    />
    <Testimonials />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import Testimonials from './Testimonials/Testimonials.vue';
import RelatedArticlesSection from './RelatedArticlesSection/RelatedArticlesSection.vue';
import downloadFile from '~/utils/helpers/downloadFile';
import { useSubscriptionStore } from '~/stores/subscription';

const ArticleLongSection = defineAsyncComponent(
  () => import('./ArticleSection/ArticleLongSection.vue')
);
const ArticleShortSection = defineAsyncComponent(
  () => import('./ArticleSection/ArticleShortSection.vue')
);

export default {
  components: {
    HeroSection,
    ArticleLongSection,
    ArticleShortSection,
    RelatedArticlesSection,
    Testimonials,
  },
  props: {
    page: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      autoDownload: false,
      subscriptionStore: useSubscriptionStore(),
    };
  },
  computed: {
    subscribed() {
      return (
        this.subscriptionStore?.subscribed &&
        this.subscriptionStore?.subscribed !== 'day'
      );
    },
    articleComponent() {
      return this.page.post_text.length > 820
        ? 'ArticleLongSection'
        : 'ArticleShortSection';
    },
    hasBlogArticles() {
      return !!this.page.related_articles.length;
    },
  },
  watch: {
    subscribed(subscribed) {
      if (subscribed) {
        if (this.autoDownload) {
          this.downloadPdf();
          this.autoDownload = false;
        }
      }
    },
  },
  methods: {
    downloadPdf() {
      if (!this.subscribed) {
        return;
      }
      downloadFile(
        `/leadgen-pages/${this.page.id}/download-file`,
        this.page.download_filename
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
